import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import React from 'react';
import {KeyboardTypeOptions, SafeAreaView, TextInput, Text} from 'react-native';
import styleSheet from './styles';

interface AdminTextInputProps {
  title: string;
  placeholder: string;
  value: string;
  isGeneral?: boolean;
  onChangeText: (text: string) => void;
  keyboardType?: KeyboardTypeOptions;
}

const AdminTextInput = observer((props: AdminTextInputProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <SafeAreaView
      style={
        props.isGeneral ? styles.containerGeneral : styles.containerRegular
      }>
      <Text style={styles.textStyle}>{props.title}</Text>
      <TextInput
        style={styles.input}
        onChangeText={text => {
          props.onChangeText(text);
        }}
        value={props.value}
        placeholder={props.placeholder}
        placeholderTextColor={theme.colors.grey300}
        keyboardType={props.keyboardType}
      />
    </SafeAreaView>
  );
});

export default AdminTextInput;
